import { Api } from 'src/common';

const getUpdateInformation = (appUpdates, abortController) => {
  const ENDPOINT = 'pending-app/codes';

  return Api.post(ENDPOINT, {
    body: JSON.stringify(appUpdates),
    signal: abortController.signal,
    headers: {
      'Content-Type': 'application/json',
    }
  }).then((response) => {
    if (!response.updateInfo?.categories) {
      return [];
    }

    return response.updateInfo.categories;
  });
};

export const PendingAppService = { getUpdateInformation };
